import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { PromotionCurrency } from '@core/models/promotion-currency.model';

@Injectable()
export class PromotionCurrencyEntityService extends EntityCollectionServiceBase<PromotionCurrency> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('PromotionCurrency', serviceElementsFactory);
  }
}